import {Button, Card, Form, Input} from "antd";
import {useGlobalState} from "app/user/GlobalStateProvider";
import {Link, useNavigate, useSearchParams} from "react-router";
import {RETURN_TO_PARAM} from "app/util/constants";
import {linkRegister} from "app/nav/links";
import {ValidateErrorEntity} from "rc-field-form/lib/interface";
import {useEffect} from "react";

interface ILoginForm {
  email: string;
  password: string;
}

const LoginForm = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const {loginUser, isLoggedIn} = useGlobalState();
  const onFinish = async (values: ILoginForm) => {
    await loginUser({
      variables: {
        input: values
      }
    });
  };

  useEffect(() => {
    if (isLoggedIn) {
      const returnTo = searchParams.get(RETURN_TO_PARAM) || "/";
      navigate(returnTo);
    }
  }, [isLoggedIn, navigate, searchParams]);

  const onFinishFailed = (errorInfo: ValidateErrorEntity<ILoginForm>) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="flex justify-center">
      <Card className="shadow-md w-md" title="Login">
        <Form<ILoginForm> layout="vertical" name="login_form" onFinish={onFinish} onFinishFailed={onFinishFailed}>
          <Form.Item<ILoginForm>
            label="Email"
            name="email"
            rules={[
              {
                required: true,
                message: "Please input your email!"
              },
              {
                type: "email",
                message: "The input is not a valid email!"
              }
            ]}
          >
            <Input autoComplete="username" placeholder="Enter your email" />
          </Form.Item>

          <Form.Item<ILoginForm>
            label="Password"
            name="password"
            rules={[
              {
                required: true,
                message: "Please input your password!"
              }
            ]}
          >
            <Input.Password autoComplete="current-password" placeholder="Enter your password" />
          </Form.Item>

          <Form.Item>
            <div className="flex gap-3 items-center">
              <Button htmlType="submit" type="primary">
                Login
              </Button>
              <div>
                Don&#39;t have an account? <Link to={linkRegister()}>Register</Link>
              </div>
            </div>
          </Form.Item>
          <div>
            <Link to="/forgot-password">Forgot password?</Link>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default LoginForm;
